import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

interface RemoveMemberConfirmationModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (memberId: string) => void;
  member: { id: string; name: string } | null;
}

const RemoveMemberConfirmationModal: React.FC<RemoveMemberConfirmationModalProps> = ({
  open,
  onClose,
  onConfirm,
  member,
}) => {
  const handleConfirm = () => {
    if (member) {
      onConfirm(member.id);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Member Removal</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          Are you sure you want to remove <strong>{member?.name || 'this member'}</strong> from the team?
          This action cannot be undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleConfirm} variant="contained" color="error">
          Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RemoveMemberConfirmationModal;
